import AppModalGeneral from 'components/atoms/AppModalGeneral/AppModalGeneral'
import { AccordionPattern } from 'components/molecules/AccordionPattern/AccordionPattern'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import { RiCloseLine } from '@remixicon/react'
import { useTemplateDetail } from 'orders/presentation/hooks/useTemplateDetail'

interface Props {
    templateId: number
    templateName: string
    isClassification: boolean
    onClose: () => void
}

export default function TemplateDetailModal({ templateId, templateName, isClassification, onClose }: Props) {
    const { template, loading } = useTemplateDetail(templateId)
    const groups = template?.groups ?? []

    return (
        <AppModalGeneral isOpen>
            <div className="relative z-10 bg-white rounded-xl shadow-xl w-full max-w-[757px] mx-4 max-h-[85vh] flex flex-col overflow-hidden">
                {/* Header */}
                <div className="flex items-start gap-4 justify-center pb-3 pl-8 pr-6 pt-6 border-b border-[#CBD5E1]">
                    <div className="flex flex-col gap-2 flex-1 min-w-0">
                        <h2 className="text-xl font-semibold text-[#141A1F]">Detalle de plantilla</h2>
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="inline-flex items-center gap-2 px-3 py-[10px] rounded-full border border-[#CBD5E1] text-sm">
                                <span className="text-[#3E5060]">Nombre</span>
                                <span className="font-medium text-[#070A13]">{templateName}</span>
                            </span>
                            <span className="inline-flex items-center gap-2 px-3 py-[10px] rounded-full border border-[#CBD5E1] text-sm">
                                <span className="text-[#3E5060]">Reglas</span>
                                <span className="font-medium text-[#141A1F]">{groups.length}</span>
                            </span>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="absolute right-[9.5px] top-[10px] p-[10px] rounded-lg text-[#94A3B8] hover:text-[#475569]"
                        aria-label="Cerrar"
                    >
                        <RiCloseLine size={24} />
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto flex-1 px-6 py-8">
                    {loading && <LoaderTransparent />}
                    {!loading && groups.length > 0 && (
                        <AccordionPattern rules={groups} isClassification={isClassification} />
                    )}
                    {!loading && groups.length === 0 && (
                        <p className="text-sm text-[#94A3B8] text-center py-8">Sin reglas disponibles</p>
                    )}
                </div>
            </div>
        </AppModalGeneral>
    )
}
